export default {
  meta: {
    title: '商机版-商机'
  }
};
